import { createAction } from '@reduxjs/toolkit';

export const dashboardUpgradeActions = {
  upgradeModal: {
    triggered: createAction('[Dashboard Upgrade Modal] triggered'),
    closed: createAction('[Dashboard Upgrade Modal] closed'),
  },
};
